module.exports = __webpack_public_path__ + "static/media/wheel-barrow.34381907.svg";